import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

/**
 * A clickable table-header cell that cycles a sort key through
 *   ascending → descending → default (parent-managed).
 * Props:
 *  - label: display text
 *  - k: sort key ("email", "level", ...)
 *  - sort: { key, dir }
 *  - setSort: setter
 *  - defaultKey: reserved "reset" key (default: "default")
 */
export default function SortableHeader({ label, k, sort, setSort, defaultKey = "default" }) {
  const active = sort.key === k;
  const toggle = () => {
    if (!active) setSort({ key: k, dir: "asc" });
    else if (sort.dir === "asc") setSort({ key: k, dir: "desc" });
    else setSort({ key: defaultKey, dir: "asc" });
  };
  const Icon = active ? (sort.dir === "asc" ? ArrowUp : ArrowDown) : ArrowUpDown;
  return (
    <th className="px-4 py-2.5 overline text-slate-600 whitespace-nowrap">
      <button
        type="button"
        data-testid={`sort-${k}`}
        onClick={toggle}
        className={`inline-flex items-center gap-1.5 uppercase tracking-wider font-semibold text-[11px] hover:text-[#0B1D3A] ${active ? "text-[#0B1D3A]" : "text-slate-600"}`}
      >
        {label}
        <Icon size={12} className={active ? "text-[#FF5A1F]" : "text-slate-400"} />
      </button>
    </th>
  );
}
